import React from 'react';
import { Card } from '@/components/ui/card';
import WorkerHatIcon from '@/assets/icons/WorkerHatIcon';
import { Link } from 'react-router-dom';
import BuildingCityIcon from '@/assets/icons/BuildingCityIcon';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import useDesktop from '@hooksV2/useDesktop';

const PropertyCompanies = ({ companies, dashboardLinkPrefix }) => {
  const isDesktop = useDesktop();
  if (companies.length < 1) return null;
  return (
    <div>
      <h3 className="text-xl font-medium mb-[13px]">
        Boligens fagfolk ({companies.length})
      </h3>
      <div className="flex flex-col gap-5">
        <div className="flex md:grid flex-col md:grid-cols-2 gap-5">
          {companies
            .filter((company) => company.hasProfileSearchAddOn)
            .map((company) => (
              <Link
                key={company.companyId}
                to={`${dashboardLinkPrefix}/company/${company.companyId}`}
              >
                <Card className="flex items-center p-3 md:p-5 shadow-none h-full rounded-md">
                  <div className="flex justify-center items-center w-full">
                    {company.logoUrl ? (
                      <img
                        className="max-h-[75px]"
                        alt="logo"
                        src={company.logoUrl}
                      />
                    ) : (
                      <WorkerHatIcon width={40} height="100%" />
                    )}
                  </div>
                  <div className="flex flex-col gap-1.5 w-full border-l pl-5 h-full">
                    <p className="text-base md:text-lg leading-5 font-medium">
                      {company.name}
                    </p>
                    <div className="flex gap-2">
                      <WorkerHatIcon />
                      <p className="text-[15px] opacity-65">
                        {company.professions?.length > 1
                          ? 'Flere fagfelt'
                          : company.professions[0]}
                      </p>
                    </div>
                    {company.franchisorCompanies?.length > 0 && (
                      <div className="flex gap-2">
                        <BuildingCityIcon />
                        <p className="text-[15px] opacity-65">
                          {company.franchisorCompanies[0].name}
                        </p>
                      </div>
                    )}
                  </div>
                </Card>
              </Link>
            ))}
        </div>
        <div className="flex md:grid flex-col md:grid-cols-2 gap-5 gap-y-3">
          {companies
            .filter((company) => !company.hasProfileSearchAddOn)
            .map((company) => (
              <Card className="flex items-center justify-between leading-[18px] shadow-none p-3 md:px-4 md:py-3 gap-4 bg-transparent rounded-md">
                <div className="overflow-hidden max-w-[235px]">
                  <Popover>
                    <PopoverTrigger disabled={isDesktop}>
                      <p
                        title={`Navn: ${company.name}`}
                        className="text-base overflow-hidden text-ellipsis whitespace-nowrap md:text-lg leading-5 font-medium"
                      >
                        {company.name}
                      </p>
                    </PopoverTrigger>
                    <PopoverContent className="max-w-xs text-xs py-1 px-2">
                      Navn: {company.name}
                    </PopoverContent>
                  </Popover>
                  <p className="text-[15px] opacity-65">
                    {company.professions[0]}
                  </p>
                </div>
                <WorkerHatIcon
                  className="opacity-40 min-w-8"
                  width={32}
                  height={32}
                />
              </Card>
            ))}
        </div>
      </div>
    </div>
  );
};

export default PropertyCompanies;
